import React from 'react';
import ScrollReveal from '../components/ScrollReveal';
import { useLanguage } from '../i18n/LanguageContext';

export default function WhyChoose() {
  const { t } = useLanguage();
  const w = t.whyChoose;

  return (
    <section id="why" className="page-section">
      <div className="container">
        <ScrollReveal className="section-head center">
          <span className="section-eyebrow">{w.eyebrow}</span>
          <div className="accent-line center" />
          <h2 className="section-title">{w.title}</h2>
          <p className="section-sub">{w.sub}</p>
        </ScrollReveal>
        <div className="why-grid">
          {w.reasons.map((r, i) => (
            <ScrollReveal key={r.title} delay={i * 60}>
              <div className="why-card">
                <h4>{r.title}</h4>
                <p>{r.desc}</p>
              </div>
            </ScrollReveal>
          ))}
        </div>
      </div>
    </section>
  );
}
